const RotateNotice = () => <div className="app-screen-popup vertical"><div className="app-screen-inner"><i className="app-screen-icon" /><span className="app-screen-text">Please rotate your screen for best experience</span></div></div>

export default RotateNotice
